/**
 * How many times a failed query is retried by default. Kept in its own module
 * so a light file such as `api/titles/titlesErrors.ts` can share it without
 * importing `queryClient.ts`, which pulls in the Redux store through
 * `utils/helpers/common`. `queryClient.ts` re-exports it.
 */
export const DEFAULT_QUERY_RETRY = 1;
